export enum ProfileAction {
  MyOrders = 'MyOrders',
  MyVisits = 'MyVisits',
  MyAccount = 'MyAccount',
  MyWallets = 'MyWallets',
  ChangeProfile = 'ChangeProfile',
  SignOut = 'SignOut',
  GuestOnBoarding = 'GuestOnBoarding',
}
